export const hasTouch = () => {
  return navigator.maxTouchPoints > 0 || "ontouchstart" in window;
};
